import { render } from "./Settings.vue?vue&type=template&id=269337d1&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=269337d1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-269337d1"

export default script